module.exports = require('./stats');




/** WEBPACK FOOTER **
 ** ./src/plugins/stats/index.js
 **/